import CashTransferSearchRequestBase from './base/CashTransferSearchRequestBase';

/**
 * @class CashTransferSearchRequest
 * @extends CashTransferSearchRequestBase
 */
class CashTransferSearchRequest extends CashTransferSearchRequestBase {

}

export default CashTransferSearchRequest;
